/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Saturday, June 18th 2022, 12:29:16 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import React from "react";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Skeleton from "@mui/material/Skeleton";
import { HexColorPicker, HexColorInput } from "react-colorful";
import { FormOptionsSeparator } from "ui-widgets/forms";

interface OSHexColorPickerProps {
  onChangeColor: (hexColor: string) => void;
  initialColor: string;
}

export const OSHexColorPicker = ({ onChangeColor, initialColor }: OSHexColorPickerProps) => {
  const [color, setColor] = React.useState(initialColor);

  const handleChangeColor = (hexColor: string) => {
    setColor(hexColor);
    onChangeColor(hexColor);
  };

  return (
    <Stack spacing={2}>
      <div className="os-input-field">
        <label htmlFor="os-color-picker">
          <Typography>Choose a color</Typography>
        </label>
        <HexColorPicker id="" color={color} onChange={handleChangeColor} />
      </div>

      <FormOptionsSeparator seperatorText="OR" />

      <Stack spacing={2}>
        <div className="os-input-field">
          <label htmlFor="os-color-picker-input">
            <Typography>Enter a Hex value</Typography>
          </label>
          <HexColorInput id="os-color-picker-input" color={color} onChange={handleChangeColor} style={{ width: 200 }} />
        </div>
      </Stack>
    </Stack>
  );
};

export const OSColorPickerSkeleton = () => {
  return (
    <Stack spacing={2}>
      <Skeleton sx={{ borderRadius: "6px" }} animation="wave" variant="rectangular" width={200} height={200} />
      <Skeleton animation="wave" variant="rectangular" width={200} height={5} />
      <Skeleton sx={{ borderRadius: "6px" }} animation="wave" variant="rectangular" width={200} height={30} />
    </Stack>
  );
};
